import { authenticated } from './WebRequest';
import { omitNil } from '../mylib/Utils';
import type {
  ApiThunk,
  InventoryConsumptionParameters,
  InventoryResponse,
  InventorySiteParameters,
  InventoryUpdateParameters,
} from './types/Inventory';

export type {
  ApiThunk,
  ColorantInventoryItem,
  ColorantInventoryMutation,
  InventoryConsumptionParameters,
  InventoryResponse,
  InventorySiteParameters,
  InventoryUpdateParameters,
} from './types/Inventory';

export function fetch_cnt_inventory(
  parameters: InventorySiteParameters
): ApiThunk<InventoryResponse> {
  const { siteid } = parameters;
  return authenticated.get(`/site/${siteid}/colorant_inventory/`);
}

export function update_cnt_inventory(
  parameters: InventoryUpdateParameters
): ApiThunk<InventoryResponse> {
  const { siteid, ...params } = omitNil(parameters);
  return authenticated.post(`/site/${siteid}/update_colorant_inventory/`, {
    params,
  });
}

export function report_cnt_consumption(
  parameters: InventoryConsumptionParameters
): ApiThunk<InventoryResponse> {
  const { siteid, ...params } = omitNil(parameters);
  return authenticated.post(`/site/${siteid}/report_colorant_consumption/`, {
    params,
  });
}
